<template lang="">
<div class="weddingCard_wrap">
    <div class="weddingCard">
        <div class="section section_1 type4">
            <h5 class="tit">
                Wedding Day
            </h5>
            <p class="sub">
                We would be grateful if you could join us on <br>
                our wedding day and bless the start of our new life together.
            </p>
            <div class="img_wrap">
                <img :src="$getImgUrl(weddingInfo.mainImgPath)" alt="">
                <div class="date">
                    <span class="month">{{ getMonthOrDay(weddingInfo.eventDate, 'month') }}</span>
                    <span class="day">{{ getMonthOrDay(weddingInfo.eventDate, 'day') }}</span>
                </div>
            </div>
            <div class="name_wrap">
                <p class="groom">{{ weddingInfo.groomName }}</p>
                <p class="bride">{{ weddingInfo.brideName }}</p>
            </div>
            <div class="detail">
                {{ $localizeDate(weddingInfo.eventDate, true) }} {{ $getDayName(weddingInfo.eventDate, true) }} {{ weddingInfo.eventTime }} <br>
                {{ weddingInfo.eventLocationName }} {{ weddingInfo.eventLocationDetail }}
            </div>
        </div>
        <div class="section section_2 type4">
            <div class="top">
                <div class="img">
                    <img src="../../../assets/images/common/ico_edit_02.png" alt="">
                </div>
                <h5 class="main_msg">{{ weddingInfo.mainMessage }}</h5>
                <span class="main_eng">Join us for the wedding</span>
                <p class="sub_msg" v-html="weddingInfo.greetingsMessage">
                </p>
            </div>
            <div class="bottom">
                <p>Our Family</p>
                <ul>
                    <li><span>신랑 부</span> {{ weddingInfo.groomFatherName }}</li>
                    <li><span>신부 부</span> {{ weddingInfo.brideFatherName }}</li>
                    <li><span>신랑 모</span> {{ weddingInfo.groomMotherName }}</li>
                    <li><span>신부 모</span> {{ weddingInfo.brideMotherName }}</li>
                    <li><span>신랑</span> {{ weddingInfo.groomName }}</li>
                    <li><span>신부</span> {{ weddingInfo.brideName }}</li>
                </ul>
            </div>
        </div>
        <div class="section section_3 type4">
            <div class="tit">Wedding Gallery</div>
            <div class="img_wrap">
                <div class="preview">
                    <img :src="$getImgUrl(weddingInfo.attachList[selectedThumbnailIdx])" alt="">
                    <div class="preview_btn">
                        <a @click="changeMainThumbnail('prev')" class="btn_prevImg"></a>
                        <a @click="changeMainThumbnail('next')" class="btn_nextImg"></a>
                    </div>
                </div>
                <ul class="thumb">
                    <li v-for="(attach, index) in weddingInfo.attachList" @click="selectThumbnail(index)"><img :src="$getImgUrl(attach)" alt="" style="width: 100%"></li>
                </ul>
            </div>
        </div>
        <div class="section section_4 type4">
            <div class="tit">
                안내 사항
            </div>
            <p class="txt mt15 padding030">
                {{ weddingInfo.noticeMessage }}
            </p>
        </div>
        <div class="section section_5 type4">
            <div class="tit">
                {{ weddingInfo.thankYouMessage }}
            </div>
            <p class="txt">
                축하의 마음을 담아 축의금을 전달해보세요.
            </p>
            <ul>
                <li v-for="congratInfo in weddingInfo.congratInfoList">
                    <span v-if="congratInfo.weddingSide === 'groom'">신랑측</span><span v-else>신부측</span> <b>{{ congratInfo.name }}</b> ({{ congratInfo.bankName }} {{ congratInfo.bankNumber }})
                </li>
            </ul>
        </div>
        <div class="section section_6 type4" v-if="weddingInfo.campaign.campaignSeq">
            <div class="tit">
                디지털 기부 화환
            </div>
            <p class="txt">
                디지털 기부 화환은 축하 화환을 디지털 화환으로 <br>
                제공 되는 서비스입니다. <br>
                디지털 화환의 결제 금액의 일부는 다양한 <br>
                사회적 활동에 기부가 됩니다.
            </p>
            <div class="box">
                <div class="img_wrap">
                    <img :src="$getImgUrl(campaignThumbnail)" alt="">
                </div>
                <div class="txt_wrap">
                    <h5>[후원캠페인]</h5>
                    <p>
                        {{ weddingInfo.campaign.campaignName }}
                    </p>
                    <div>기본 운영비 <span>{{ $addComma(weddingInfo.campaign.campaignAmount) }}원</span></div>
                </div>
            </div>
            <div class="btn_wrap">
                <a href="" class="btn_view">미리보기</a>
                <a class="btn_support" @click="makePayment">후원하기</a>
            </div>
        </div>
        <div class="section section_7 type4">
            <div class="tit">
                오시는 길
            </div>
            <p class="txt">
                {{ weddingInfo.mapAddress }} <br>
                {{ weddingInfo.eventLocationName }}
            </p>
            <div class="map_wrap">
                <div id="map">
                    지도
                </div>
            </div>
        </div>
    </div>
</div>

</template>
<script>
export default {
    props: {
        weddingInfo: {
            type: Object,
            required: true
        },
        invitationSeq: {
            type: String
        }
    },

    data () {
        return {
            selectedThumbnailIdx: 0,
        }
    },

    methods: {
        selectThumbnail (i) {
            this.selectedThumbnailIdx = i;
        },

        changeMainThumbnail (direction) {
            if (direction == 'prev' && this.selectedThumbnailIdx != 0) {
                this.selectedThumbnailIdx -= 1
            } else if (direction == 'next' && this.selectedThumbnailIdx != this.weddingInfo.attachList.length - 1){
                this.selectedThumbnailIdx += 1
            }
        },

        makePayment () {
            const paymentAmount = this.weddingInfo.campaign.campaignAmount
            const campaignName = this.weddingInfo.campaign.campaignName
            const invitationSeq = this.invitationSeq
            this.$openModal('paymentModal', {
                paymentAmount: paymentAmount,
                campaignName: campaignName,
                invitationSeq: invitationSeq,
                invitationType: 'W'
            })
        },

        getMonthOrDay(dateString, type) {
            if (type === 'month') {
                return dateString.substring(5, 7)
            } else {
                return dateString.substring(8, 10)
            }
        },

        initMap (x, y, name) {
            var container = document.getElementById('map');
            var options = {
                center: new kakao.maps.LatLng(x, y),
                level: 4,
                draggable: false
            };
            this.map = new kakao.maps.Map(container, options);
            this.marker = new kakao.maps.Marker({
                position: options.center,
                map: this.map,
            });
            if (name) {
                this.infoWindow = new kakao.maps.InfoWindow({
                    content: `<div style="padding:5px;font-size:14px;">${name}</div>`,
                });
                this.infoWindow.open(this.map, this.marker);
            }
        },

    },

    mounted () {
        this.initMap(this.weddingInfo.eventLatitude, this.weddingInfo.eventLongitude, this.weddingInfo.eventLocationName)
    },

    computed: {
        campaignThumbnail() {
            return this.weddingInfo?.campaign?.campaignThumbnailPath || '';
        }
    }
}
</script>
<style lang="">

</style>